import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax

const accessToken = 'pk.eyJ1Ijoic2RlZXJlIiwiYSI6ImNrb3VpbWh4YzAwcDAycm5ybGtob3JyM24ifQ.JnXmX6WCzoPxy6cNShedJg';
mapboxgl.accessToken = accessToken;

export function instantiateMap(state, container){
    const { lng, lat, zoom } = state;
    const map = new mapboxgl.Map({
        container: container,
        style: 'mapbox://styles/mapbox/streets-v11',
        center: [lng, lat],
        zoom: zoom
    });

    return map
}